import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import GeneralDialogLayout from '@Containers/Dialogs/GeneralDialogLayout/GeneralDialogLayout';
import RxSpinnerComponent from '@Components/Results/utils/rx-spinner.component';
import * as Results from '@Services/Results';
import InnerHTML from '@Components/InnerHTML';
import { closeDialog } from '@Containers/Dialogs/DialogsActions';
import { ButtonWithIcon } from '@els/els-react--button';
import { typeOfTitlesAbstractsModal } from './TitlesAbstractsModalConstants';

import './TitlesAbstractsModal.scss';

function TitlesAbstracts({ modalId = '', citation = {}, goToContext = () => {}, ...rest }) {
  const [titlesInfo, setTitlesInfo] = useState({});
  const [showSpinner, setShowSpinner] = useState(false);
  const dispatch = useDispatch();
  const getTitles = () => {
    setShowSpinner(true);
    const { id, resultName, databaseId } = citation;
    Results.getTitlesAbstractsForCitations(resultName, databaseId, id)
      .then((info) => {
        setTitlesInfo(info);
      })
      .finally(() => setShowSpinner(false))
      .catch(Logger.error);
  };

  useEffect(() => {
    getTitles();
    return () => {
      dispatch(
        closeDialog({
          id: typeOfTitlesAbstractsModal,
        })
      );
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  useEffect(() => {
    getTitles();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [modalId]);
  return (
    <GeneralDialogLayout
      key={modalId}
      className="titles-abstracts-modal"
      {...rest}
      header={
        <div className="titles-abstracts-modal-header">
          <h4 className="rx-newmodal-title">Title/Abstract</h4>
        </div>
      }
      footer={
        <div className="titles-abstracts-modal-footer">
          <span className="titles-abstracts-btn-group">
            <ButtonWithIcon
              data-e2e="titles-abstracts-show-details"
              name="Show details"
              aria-label="Show details"
              type="tertiary"
              sprite="ChevronRight"
              size="small"
              iconRight
              tabIndex="0"
              onClick={() => {
                goToContext('citations', citation);
                dispatch(
                  closeDialog({
                    id: typeOfTitlesAbstractsModal,
                  })
                );
              }}
              className="titles-abstracts-show-button e2e-titles-abstracts-show-details">
              Show details
            </ButtonWithIcon>

            <ButtonWithIcon
              data-e2e="titles-abstracts-ok"
              type="primary"
              sprite="ChevronRight"
              iconRight
              name="OK"
              tabIndex="0"
              aria-label="OK"
              onClick={() => {
                dispatch(
                  closeDialog({
                    id: typeOfTitlesAbstractsModal,
                  })
                );
              }}
              className="e2e-titles-abstracts-ok">
              OK
            </ButtonWithIcon>
          </span>
        </div>
      }>
      <div className="titles-abstracts__content">
        {showSpinner && <RxSpinnerComponent autoStart spinnerScale={1} spinnerId="titles-abstracts-modal-loading" />}
        <section className="rx-newmodal-content rx-newmodal-content-main no-max-width-p">
          {!showSpinner && (
            <>
              <InnerHTML tag="p" html={titlesInfo.title || ''} />
              <InnerHTML tag="p" className="typogaphy-small" html={titlesInfo.abstractText || ''} />
            </>
          )}
        </section>
      </div>
    </GeneralDialogLayout>
  );
}

TitlesAbstracts.propTypes = {
  modalId: PropTypes.string,
  citation: PropTypes.object,
  goToContext: PropTypes.func,
};

export default TitlesAbstracts;
